import * as React from "react";

export const MyPicksPage: React.FC = () => {
  return <div className="my-picks-page">Coming soon...</div>;
};
